import { render, staticRenderFns } from "./processSetUIView.vue?vue&type=template&id=1cba9674&"
import script from "./processSetUIView.vue?vue&type=script&lang=js&"
export * from "./processSetUIView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports